// When Convermax did not supply a model and the part fits exactly one model,
// use that model so model-specific engravings load. A model that is already
// set (a selected vehicle) is left alone. The theme applies the same rule in
// shopify/sections/3dcustomizer.liquid.

export function applySingleModelWhenUnset(fitment) {
  if (!fitment || typeof fitment !== "object") return fitment;

  const current = typeof fitment.model === "string" ? fitment.model.trim() : "";
  if (current) {
    fitment.model = current;
    return fitment;
  }

  const models = Array.isArray(fitment.models) ? fitment.models : [];
  const only = models.length === 1 && typeof models[0] === "string" ? models[0].trim() : "";
  fitment.model = only ? only.toLowerCase() : "";
  return fitment;
}
